export { default } from './ListItemAvatar';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/ListItemAvatar/index.js
// module id = 802
// module chunks = 121